<template>
  <section class="page-qualify">
    <div
      v-for="(image, index) in images"
      :key="index"
    >
      <van-image
        class="image-content"
        @click="handlePreview(index)"
        :src="image"
      >
        <template v-slot:loading>
          <van-loading
            type="spinner"
            size="20"
          />
        </template>
        <template v-slot:error>加载失败</template>
      </van-image>
      <div class="tips">（支持点击查看大图）</div>
    </div>
  </section>
</template>

<script>
import { ImagePreview } from 'vant';
import image from './images/image.png';
import image2 from './images/image2.png';

export default {
  created() {
    document.title = '公司资质';
  },
  data() {
    return {
      images: [image, image2],
    };
  },
  methods: {
    handlePreview(index) {
      ImagePreview({
        images: [this.images[index]],
        closeable: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-qualify {
  padding: 10px;

  > div {
    margin-bottom: 30px;
  }

  .image-content {
    min-height: 100px;
  }

  .tips {
    font-size: 13px;
    text-align: center;
    opacity: 0.5;
    margin-top: 10px;
  }
}
</style>
